import { Typography } from "@mui/material";
import { styled } from '@mui/system';

interface ProductCardProps {
    icon: string;
    iconAlt: string;
    title: string;
    color: string;
    description: string;
    subDescription?: string;
    padding?: string;
}

const ProductCardContainer = styled('div')<{ padding?: string }>(({ padding }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#002322',
    height: "218px",
    margin: "0 auto",
    padding: padding,
    '@media (max-width: 1024px)': {
        minHeight: "180px",
        padding: "24px",
        justifyContent: 'center',
        gap: '16px'
    }
}));

const ProductCardIcon = styled('img')({
    width: '48px',
    height: '48px',
    marginBottom: '12px',
    '@media (max-width: 1024px)': {
        width: '40px',
        height: '40px',
        marginBottom: '8px',
    }
});

const ProductCardTextContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '3px',
    '@media (max-width: 1024px)': {
        gap: '2px',
    }
});

const ProductCardTitle = styled(Typography<'h3'>)(({ color }) => ({
    color: color,
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '24px',
    textAlign: 'center',
    '@media (max-width: 1024px)': {
        fontSize: '14px',
        lineHeight: '20px',
    }
}));

const ProductCardDescription = styled(Typography<'p'>)(({
    color: "#F1F7F7",
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '18px',
    '@media (max-width: 1024px)': {
        fontSize: '12px',
        lineHeight: '16px',
    }
}));

const ProductCardSubDescription = styled(Typography<'p'>)(({
    color: "#F1F7F7",
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '18px',
    textAlign: 'center',
    '@media (max-width: 1024px)': {
        fontSize: '10px',
        lineHeight: '14px',
    }
}));


export const ProductCard = ({ icon, iconAlt, title, color, description, subDescription, padding }: ProductCardProps) => {
    return (
        <ProductCardContainer padding={padding}>
            <ProductCardIcon src={icon} alt={iconAlt} />
            <ProductCardTextContainer>
                <ProductCardTitle color={color} component="h3">{title}</ProductCardTitle>
                <ProductCardDescription color={color} component="p">{description}</ProductCardDescription>
                {subDescription && <ProductCardSubDescription color={color} component="p">{subDescription}</ProductCardSubDescription>}
            </ProductCardTextContainer>
        </ProductCardContainer>
    );
};
